import React from 'react';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useExtrasFormContext } from '../helpers/useExtrasFormContext';
import { getNestedInputName } from '../nested-input/getNestedInputName';
import { INestedInputLevel } from '../nested-input/INestedInputLevel';
import { StyledSubcategoryRadioButton } from './SubcategoryRadioButton';
import { Path } from 'react-hook-form';
import { IExtrasFormData } from '../IExtrasFormData';

interface ISubcategoryBlankProps {
	nestedInputLevel: INestedInputLevel;
}

export const SubcategoryRadioButtonBlank = ({
	nestedInputLevel,
}: ISubcategoryBlankProps) => {
	const { t } = useTranslation();
	const { register } = useExtrasFormContext();

	const name = getNestedInputName(
		nestedInputLevel,
		'selected',
	) as Path<IExtrasFormData>;

	return (
		<StyledSubcategoryRadioButton
			value=""
			label={t('parking_booking_extras_no_services_needed')}
			{...register(name)}
		/>
	);
};
